export default "__VITE_ASSET__etSQHIRk__"